export function FloatingActionBttn() {
  return (
    <>
      <a href="#top">
        <button className="bttn bttn-floating-action">Up</button>
      </a>
    </>
  );
}
